import { Link } from 'gatsby'
import React, { Fragment, useState } from 'react'

import { WhatsAppIcon } from '../../../../../assets/WhatsAppIcon'
import { useWhatsappOfferEvent } from '../../../../../hooks/useWhatsappOfferEvents'
import OffersWhatsappModal from '../../../../sections/OffersWhatsappModal'
import EngagementModal from '../../../EngagementModal'

import type { MenuLines } from '../../../../../types/CMS'
import './desktop-first-menu.scss'

type Props = {
  menu: MenuLines[] | undefined
  hasWhatsappOffers: boolean | undefined
}

export const DesktopFirstMenu = ({ menu, hasWhatsappOffers }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false)
  const { openModalEvent } = useWhatsappOfferEvent()

  if (!menu || menu.length === 0) return null

  return (
    <>
      {menu?.map((item, index) => {
        if (!item?.title) return null

        const useUrlParam = item.url.charAt(0) === '?'
        const urlParam = item.url.split('?')[1]

        if (useUrlParam && urlParam === 'openModalDownloadApp=true') {
          return (
            <Fragment key={item.title}>
              <div key={item.title} className="first-promotional-menu-item">
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="menu-item-button"
                >
                  {item?.title}
                </button>
              </div>

              <EngagementModal
                isModalOpen={isModalOpen}
                handleCloseModal={() => setIsModalOpen(false)}
              />
            </Fragment>
          )
        }

        return (
          <div
            key={`${item.title}--${index}`}
            className="first-promotional-menu-item"
            data-testid={`menu-first-${index}`}
          >
            <Link to={item?.url ?? '/'} data-store-link>
              {item?.title}
            </Link>
          </div>
        )
      })}

      {hasWhatsappOffers && (
        <>
          <div
            className="whatsApp-promotional-menu-item"
            data-testid="whatsApp-promotional-menu-item"
            onClick={() => {
              setIsWhatsappModalOpen(true)
              openModalEvent({
                buttonText: 'Ofertas pelo WhatsApp',
                location: 'header',
              })
            }}
          >
            <WhatsAppIcon width={20} height={20} />
            <span>Ofertas pelo WhatsApp</span>
          </div>

          <OffersWhatsappModal
            openModal={isWhatsappModalOpen}
            setOpenModal={setIsWhatsappModalOpen}
          />
        </>
      )}
    </>
  )
}
